module.exports = __webpack_public_path__ + "img/needymeds.9903039.jpg";